App.controller('HealthInsuranceWithPaymentsFormCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'insuranceService', 'statesService', '$filter', 'profileService', 'dataUser', '$q', '$rootScope', 'healthInsuranceService', 'popUpService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, insuranceService, statesService, $filter, profileService, dataUser, $q, $rootScope, healthInsuranceService, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja (dane i oświadczenia)';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.healthInsuranceWithPayments.package';
    $scope.$emit('link', $scope.link);

    $scope.data = {};

    $scope.package = $scope.stateParams.package;
    $scope.data.benefit = $scope.package;

    $scope.mainCareLocationList = [
        "ALEKSANDRÓW KUJAWSKI",
        "ALEKSANDRÓW ŁÓDZKI",
        "ANDRYCHÓW",
        "AUGUSTÓW",
        "BARCIN",
        "BARLINEK",
        "BARTOSZYCE",
        "BEŁCHATÓW",
        "BĘDZIN",
        "BIAŁA PODLASKA",
        "BIAŁOBRZEGI",
        "BIAŁOGARD",
        "BIAŁY BÓR",
        "BIAŁYSTOK",
        "BIELAWA",
        "BIELSK PODLASKI",
        "BIELSKO-BIAŁA",
        "BIELSKO-BIAŁA (NET)",
        "BIERUŃ",
        "BIŁGORAJ",
        "BŁASZKI",
        "BŁONIE",
        "BOCHNIA",
        "BOLESŁAWIEC",
        "BRALIN",
        "BRANICE",
        "BRANIEWO",
        "BRODNICA",
        "BRUDZOWICE",
        "BRZEG",
        "BRZEG (NET)",
        "BRZEG DOLNY",
        "BRZESKO",
        "BRZESZCZE",
        "BRZEZIE",
        "BRZEZINY",
        "BRZOZÓW",
        "BUKOWIEC",
        "BUSKO-ZDRÓJ",
        "BYDGOSZCZ",
        "BYTOM",
        "BYTÓW",
        "CHEŁM - CEMEX",
        "CHEŁM (NET)",
        "CHEŁMEK",
        "CHEŁMNO",
        "CHEŁMNO (NET)",
        "CHEŁMŻA",
        "CHOCIANÓW",
        "CHODZIEŻ",
        "CHOJNICE",
        "CHOJNÓW",
        "CHORULA",
        "CHORZÓW",
        "CHOSZCZNO",
        "CHOTOMÓW",
        "CHRZANÓW",
        "CIECHANÓW",
        "CIECHOCINEK",
        "CIESZYN",
        "CZARNE",
        "CZARNKÓW",
        "CZECHOWICE-DZIEDZICE",
        "CZELADŹ",
        "CZERWIONKA-LESZCZYNY",
        "CZĘSTOCHOWA",
        "CZŁUCHÓW",
        "DARŁOWO",
        "DĄBROWA BIAŁOSTOCKA",
        "DĄBROWA GÓRNICZA",
        "DĄBROWA TARNOWSKA",
        "DĘBICA",
        "DĘBICA (NET)",
        "DĘBLIN",
        "DOBRODZIEŃ",
        "DOROHUSK",
        "DRAWSKO POMORSKIE",
        "DREZDENKO",
        "DUSZNIKI ZDRÓJ",
        "DYNÓW",
        "DZIAŁDOWO",
        "DZIERŻONIÓW",
        "ELBLĄG",
        "EŁK",
        "GARWOLIN",
        "GDAŃSK",
        "GDYNIA",
        "GIŻYCKO",
        "GLIWICE",
        "GŁOGÓW",
        "GŁUBCZYCE",
        "GŁUCHOŁAZY",
        "GNIEW",
        "GNIEZNO",
        "GOLENIÓW",
        "GOLUB-DOBRZYŃ",
        "GOŁDAP",
        "GORLICE",
        "GORZÓW WIELKOPOLSKI",
        "GORZYCE",
        "GOSTYNIN",
        "GOSTYŃ",
        "GOSZCZ",
        "GOWOROWO",
        "GÓRA",
        "GÓRA KALWARIA",
        "GRAJEWO",
        "GRODKÓW",
        "GRODZISK MAZOWIECKI",
        "GRODZISK WIELKOPOLSKI",
        "GRÓJEC",
        "GRUDZIĄDZ",
        "GRYFICE",
        "GRYFINO",
        "GUBIN",
        "HAJNÓWKA",
        "HRUBIESZÓW",
        "HRUSZNIEW",
        "IŁAWA",
        "INOWROCŁAW",
        "INOWROCŁAW (NET)",
        "JANÓW LUBELSKI",
        "JANÓW PODLASKI",
        "JAROCIN",
        "JAROSŁAW",
        "JASŁO",
        "JASTRZĘBIE-ZDRÓJ",
        "JAWOR",
        "JAWORZNO",
        "JELENIA GÓRA",
        "JĘDRZEJÓW",
        "JORDANÓW",
        "KALISZ",
        "KALWARIA ZEBRZYDOWSKA",
        "KAMIENNA GÓRA",
        "KAMIEŃ POMORSKI",
        "KARTUZY",
        "KARTUZY (NET)",
        "KATOWICE",
        "KAZIMIERZA WIELKA",
        "KĘDZIERZYN-KOŹLE",
        "KĘPNO",
        "KĘTRZYN",
        "KĘTY",
        "KIELCE",
        "KLUCZBORK",
        "KŁOBUCK",
        "KŁODAWA",
        "KŁODZKO",
        "KOBIERZYCE",
        "KOLBUDY",
        "KOLBUSZOWA",
        "KOLNO",
        "KOLUSZKI",
        "KOŁO",
        "KOŁOBRZEG",
        "KONIECPOL",
        "KONIN",
        "KOŃSKIE",
        "KOSTRZYN NAD ODRĄ",
        "KOSZALIN",
        "KOŚCIAN",
        "KOŚCIERZYNA",
        "KOWARY",
        "KOZIENICE - ELEKTROWNIA",
        "KOZIENICE (NET)",
        "KRAKÓW",
        "KRAPKOWICE",
        "KRASNYSTAW",
        "KRAŚNIK",
        "KROSNO",
        "KROSNO ODRZAŃSKIE",
        "KROŚNIEWICE",
        "KROTOSZYN",
        "KRUSZWICA",
        "KRYNICA-ZDRÓJ",
        "KRZEPICE",
        "KUDOWA ZDRÓJ",
        "KUTNO",
        "KWIDZYN",
        "LEGIONOWO",
        "LEGNICA",
        "LESKO",
        "LESZNO",
        "LEŻAJSK",
        "LEŻAJSK PM",
        "LĘBORK",
        "LIBIĄŻ",
        "LIDZBARK",
        "LIDZBARK WARMIŃSKI",
        "LIMANOWA",
        "LIPNIK",
        "LIPNO",
        "LIPSKO",
        "LUBACZÓW",
        "LUBAŃ",
        "LUBARTÓW",
        "LUBIANA",
        "LUBIN",
        "LUBLIN",
        "LUBLINIEC",
        "LUBOŃ",
        "LUBSKO",
        "LUZINO",
        "LWÓWEK ŚLĄSKI",
        "ŁAŃCUT",
        "ŁASK",
        "ŁASK (NET)",
        "ŁAZISKA GÓRNE",
        "ŁĘCZNA",
        "ŁĘCZYCA",
        "ŁĘCZYCA (NET)",
        "ŁOBEZ",
        "ŁOCHÓW",
        "ŁOMŻA",
        "ŁOSICE",
        "ŁOWICZ",
        "ŁÓDŹ",
        "ŁUKÓW",
        "MAKÓW MAZOWIECKI",
        "MALBORK",
        "MAŁASZEWICE",
        "MAŁKINIA",
        "MIASTECZKO ŚLĄSKIE",
        "MIECHÓW",
        "MIELEC",
        "MIĘDZYCHÓD",
        "MIĘDZYRZEC PODLASKI",
        "MIĘDZYRZECZ",
        "MIĘDZYZDROJE",
        "MIKOŁÓW",
        "MIKOŁÓW (NET)",
        "MILICZ",
        "MIŃSK MAZOWIECKI",
        "MIŃSK MAZOWIECKI (NET)",
        "MIRKÓW",
        "MIRKÓW K. WROCŁAWIA",
        "MŁAWA",
        "MOGILNO",
        "MOŃKI",
        "MORĄG",
        "MRĄGOWO",
        "MSZANA DOLNA",
        "MSZCZONÓW",
        "MUROWANA GOŚLINA",
        "MUSZYNA",
        "MYSŁOWICE",
        "MYSZKÓW",
        "MYŚLENICE",
        "MYŚLIBÓRZ",
        "NAKŁO NAD NOTECIĄ",
        "NAŁĘCZÓW",
        "NAMYSŁÓW",
        "NASIELSK",
        "NIDZICA",
        "NIEMCZA",
        "NIEPOŁOMICE",
        "NIEZNANA LOKALIZACJA",
        "NISKO",
        "NOWA CERKIEW",
        "NOWA DĘBA",
        "NOWA RUDA",
        "NOWA SARZYNA",
        "NOWA SÓL",
        "NOWE MIASTO LUBAWSKIE",
        "NOWOGARD",
        "NOWY DWÓR GDAŃSKI",
        "NOWY DWÓR GDAŃSKI (NET)",
        "NOWY DWÓR MAZOWIECKI",
        "NOWY SĄCZ",
        "NOWY TARG",
        "NOWY TOMYŚL",
        "NYSA",
        "OBORNIKI",
        "OBORNIKI (NET)",
        "OBORNIKI ŚLĄSKIE",
        "OLECKO",
        "OLESNO",
        "OLEŚNICA",
        "OLEŚNICA (NET)",
        "OLKUSZ",
        "OLSZTYN",
        "OŁAWA",
        "OPALENICA",
        "OPATÓW",
        "OPOCZNO",
        "OPOLE",
        "OPOLE LUBELSKIE",
        "ORNETA",
        "ORZYSZ",
        "OSTROŁĘKA",
        "OSTROWIEC ŚWIĘTOKRZYSKI",
        "OSTRÓDA",
        "OSTRÓW MAZOWIECKA",
        "OSTRÓW WIELKOPOLSKI",
        "OSTRZESZÓW",
        "OŚWIĘCIM",
        "OTWOCK",
        "OZIMEK",
        "OZORKÓW",
        "OŻARÓW MAZOWIECKI",
        "PABIANICE",
        "PACZKÓW",
        "PAJĘCZNO",
        "PARCZEW",
        "PASŁĘK",
        "PCIM",
        "PIASECZNO",
        "PIEKARY ŚLĄSKIE",
        "PIŁA",
        "PIŃCZÓW",
        "PIONKI",
        "PIOTRKÓW TRYBUNALSKI",
        "PISARZOWICE",
        "PISZ",
        "PLATERÓW",
        "PLESZEW",
        "PŁOCK",
        "PŁOŃSK",
        "PNIEWY",
        "PODDĘBICE",
        "PODDĘBICE (NET)",
        "POLANICA-ZDRÓJ",
        "POLICE",
        "POLKOWICE",
        "POŁCZYN-ZDRÓJ",
        "POZNAŃ",
        "PROSZOWICE",
        "PRUDNIK",
        "PRUSZCZ GDAŃSKI",
        "PRUSZKÓW",
        "PRZASNYSZ",
        "PRZEMYŚL",
        "PRZEWORSK",
        "PRZEŹMIEROWO",
        "PRZYSUCHA",
        "PSZCZYNA",
        "PUCK",
        "PUŁAWY",
        "PUŁTUSK",
        "PUSZCZYKOWO",
        "PYRZYCE",
        "PYSKOWICE",
        "RABKA-ZDRÓJ",
        "RACIBÓRZ - MIESZKO",
        "RACIBÓRZ (NET)",
        "RADLIN",
        "RADOM",
        "RADOMSKO",
        "RADZIEJÓW",
        "RADZYMIN",
        "RADZYŃ PODLASKI",
        "RAKONIEWICE",
        "RAWA MAZOWIECKA",
        "RAWICZ",
        "ROGOŹNO",
        "ROPCZYCE",
        "RUDA ŚLĄSKA",
        "RUDNIKI - CEMEX",
        "RUDNIKI (NET)",
        "RUMIA",
        "RUSIEC",
        "RUSKÓW",
        "RYBNIK",
        "RYDUŁTOWY",
        "RYKI",
        "RYPIN",
        "RZECZENICA",
        "RZESZÓW",
        "SANDOMIERZ",
        "SANOK",
        "SEJNY",
        "SĘPÓLNO KRAJEŃSKIE",
        "SIEDLCE",
        "SIEMIANOWICE ŚLĄSKIE",
        "SIEMIATYCZE",
        "SIERADZ",
        "SIERPC",
        "SIEWIERZ",
        "SITKÓWKA-NOWINY",
        "SKAŁĄGI",
        "SKARŻYSKO-KAMIENNA",
        "SKAWINA",
        "SKIERNIEWICE",
        "SKOCZÓW",
        "SKWIERZYNA",
        "SŁAWA",
        "SŁAWNO",
        "SŁUBICE",
        "SŁUPCA",
        "SŁUPIA JĘDRZEJOWSKA",
        "SŁUPSK",
        "SOCHACZEW",
        "SOKOŁÓW PODLASKI",
        "SOKÓŁKA",
        "SOPOT",
        "SOSNOWIEC",
        "STALOWA WOLA",
        "STARA WIEŚ",
        "STARACHOWICE",
        "STARGARD SZCZECIŃSKI",
        "STARGARD SZCZECIŃSKI (NET)",
        "STAROGARD GDAŃSKI",
        "STASZÓW",
        "STĘSZEW",
        "STRYKÓW",
        "STRZEGOM",
        "STRZELCE KRAJEŃSKIE",
        "STRZELCE OPOLSKIE",
        "STRZELIN",
        "STRZYŻÓW",
        "SUCHA BESKIDZKA",
        "SULECHÓW",
        "SULEJÓWEK",
        "SULĘCIN",
        "SUŁKOWICE",
        "SUWAŁKI",
        "SWARZĘDZ",
        "SYCÓW",
        "SZAMOTUŁY",
        "SZAMOTUŁY 1",
        "SZCZAWNICA",
        "SZCZAWNO-ZDRÓJ",
        "SZCZECIN",
        "SZCZECINEK",
        "SZCZEKOCINY",
        "SZCZYTNO",
        "SZLICHTYNGOWA",
        "SZPROTAWA",
        "SZTUM",
        "SZUBIN",
        "SZYDŁOWIEC",
        "ŚREM",
        "ŚRODA ŚLĄSKA",
        "ŚRODA ŚLĄSKA (NET)",
        "ŚRODA WIELKOPOLSKA",
        "ŚWIDNICA",
        "ŚWIDNIK",
        "ŚWIDWIN",
        "ŚWIEBODZICE",
        "ŚWIEBODZIN",
        "ŚWIECIE",
        "ŚWIECIE (NET)",
        "ŚWIECIE 3",
        "ŚWIĘTOCHŁOWICE",
        "ŚWINOUJŚCIE",
        "TARNOBRZEG",
        "TARNOWSKIE GÓRY",
        "TARNOWSKIE GÓRY (NET)",
        "TARNÓW",
        "TARNÓW OPOLSKI",
        "TĄPKOWICE",
        "TCZEW",
        "TERESIN",
        "TERESPOL",
        "TOMASZÓW LUBELSKI",
        "TOMASZÓW MAZOWIECKI",
        "TORUŃ",
        "TRZCIANKA",
        "TRZEBINIA",
        "TRZEBNICA",
        "TRZEBNICA (NET)",
        "TUCHOLA",
        "TUCHÓW",
        "TUREK",
        "TYCHY",
        "USTROŃ",
        "USTRZYKI DOLNE",
        "WADOWICE",
        "WADOWICE (NET)",
        "WAŁBRZYCH",
        "WAŁCZ",
        "WARKA",
        "WARSZAWA",
        "WARTA BOLESŁAWIECKA",
        "WĄBRZEŹNO",
        "WĄGROWIEC",
        "WEJHEROWO",
        "WĘGORZEWO",
        "WĘGRÓW",
        "WIELICZKA",
        "WIELUŃ",
        "WIERUSZÓW",
        "WISŁA",
        "WŁADYSŁAWOWO",
        "WŁOCŁAWEK",
        "WŁODAWA",
        "WŁOSZCZOWA",
        "WODZISŁAW ŚLĄSKI",
        "WOJKOWICE",
        "WOLBÓRZ",
        "WOLBROM",
        "WOLSZTYN",
        "WOŁCZYN",
        "WOŁOMIN",
        "WOŁÓW",
        "WROCŁAW",
        "WRZEŚNIA",
        "WSCHOWA",
        "WYRZYSK",
        "WYSOKIE MAZOWIECKIE",
        "WYSZKÓW",
        "WYSZKÓW (NET)",
        "ZABIERZÓW",
        "ZABRZE",
        "ZAKOPANE",
        "ZAMBRÓW",
        "ZAMOŚĆ",
        "ZAWIERCIE",
        "ZĄBKI",
        "ZĄBKOWICE ŚLĄSKIE",
        "ZBĄSZYNEK",
        "ZBĄSZYŃ",
        "ZDUŃSKA WOLA",
        "ZDZIESZOWICE",
        "ZGIERZ",
        "ZGORZELEC",
        "ZIELONA GÓRA",
        "ZIELONKA",
        "ZŁOCIENIEC",
        "ZŁOTORYJA",
        "ZŁOTÓW",
        "ZWOLEŃ",
        "ŻAGAŃ",
        "ŻARY",
        "ŻNIN",
        "ŻNIN (NET)",
        "ŻORY",
        "ŻUKOWO",
        "ŻUROMIN",
        "ŻYRARDÓW",
        "ŻYWIEC",
    ]

    if (!$scope.package) {
        $state.go('root.home.healthInsuranceWithPayments.package');
    }
    healthInsuranceService.getLastActiveDeclaration('LUXMED').then(function (data) {
        if (data.status === 200) {
            var lastDeclaration = data.data;
            if (lastDeclaration.status === 'ENDED') {
                if (lastDeclaration.endedDate) {
                    var endedDate = new Date(lastDeclaration.endedDate);
                    endedDate.setMonth(endedDate.getMonth() + 11);;
                    endedDate.setHours(0, 0, 0, 0);
                    var beginningOfTheMonth = new Date();
                    beginningOfTheMonth.setDate(1);
                    beginningOfTheMonth.setHours(0, 0, 0, 0);
                    if (beginningOfTheMonth.getTime() < endedDate.getTime()) {
                        $scope.showPopUp('', 'Nie można wypełnić dekalracji', 'Brak możliwości ponownego przystąpienia przed upływem 12 miesięcy od dnia zakończenia ostatniego okresu posiadania opieki.', 'Wróć do strony głównej', 'root.dashboard');
                    }
                }
            }
        }
    })

    $scope.packageWithRehabilitation = false;
    $scope.pricePackage = 0;
    $scope.namePackage = '';
    if ($scope.package) {
        $scope.packageWithRehabilitation = typeof $scope.package.selectedRehabilitation !== 'undefined' && $scope.package.selectedRehabilitation;
        $scope.pricePackage = $scope.packageWithRehabilitation ?
            $scope.package.summaryPrice + $scope.package.rehabilitationPrice :
            $scope.package.summaryPrice;
        $scope.namePackage = $scope.packageWithRehabilitation ?
            $scope.package.groupName + ' - ' + $scope.package.name + ' + Rehabilitacja' :
            $scope.package.groupName + ' - ' + $scope.package.name;
    }

    if ($scope.data.benefit) {
        delete $scope.data.benefit.creationTime;
        delete $scope.data.benefit.benefitGroup.creationTime;
    }

    $scope.userData = JSON.parse(window.sessionStorage.getItem('userObject'));

    $scope.data.person = $scope.userData.person;
    delete $scope.data.person.creationTime;


    if ($scope.data.person.identifierType == null || $scope.data.person.identifierType === 'undefined') {

        $scope.data.person.citizenshipType = 'POLISH';
        $scope.data.person.identifierType = 'PESEL';

    }

    if ($scope.userData.person.address && $scope.userData.person.address.city) {
        $scope.data.person.address = angular.copy($scope.userData.person.address);
        delete $scope.data.person.address.creationTime;
    } else {
        if ($stateParams.lastDeclaration) {
            $scope.data.person.address = angular.copy($stateParams.lastDeclaration.person.address);
            delete $scope.data.person.address.creationTime;
        }
    }

    if ($scope.data.person.address) {
        $scope.data.person.mainCareLocation = $filter('mainCareLocationFromZipCode')($scope.data.person.address.zipCode);
    }

    $scope.requiredStatementsWitDeductionFromSalary = [
        {
            list: [
                {
                    codeName: ['deductionConsent'],
                    text: '1. Proszę o comiesięczne potrącenie z mojego wynagrodzenia (oraz innych świadczeń związanych z pracą/zleceniem) wartości wybranego przeze mnie pakietu w TU Zdrowie SA.'
                },
                {
                    codeName: ['acceptsPersonalDataProcessing', 'knowsInformationObligation', 'acceptsAccessingInformationAboutCircumstances'],
                    text: '2. Wyrażam zgodę na przetwarzanie przez Towarzystwo Ubezpieczeń ZDROWIE S.A. moich danych osobowych, w tym danych o stanie zdrowia w celu wykonywania umowy ubezpieczenia.<br>' +
                        '3. Zapoznałem/zapoznałam się z <a href="' + $rootScope.CONFIGURATOR.healthInsurance.dataProcessingAgreementFileUrl + '" target="_blank">' +
                        'treścią obowiązku informacyjnego' +
                        '</a> TU ZDROWIE S.A.<br>' +
                        '4. Wyrażam zgodę na uzyskiwanie przez Towarzystwo Ubezpieczeń ZDROWIE S.A. w pełnym zakresie informacji o okolicznościach związanych z ustaleniem prawa do świadczenia z zawartej umowy ubezpieczenia i wysokością tego świadczenia, w tym wszelkich informacji i dokumentacji dotyczących stanu mojego zdrowia oraz świadczeniach zdrowotnych z których korzystałem od każdego lekarza, u którego leczyłem(am) się lub zasięgałem(am) porady medycznej, a także we wszystkich placówkach medycznych, które udzielały mi usług medycznych, zgodnie z art. 38. Ustawy o działalności ubezpieczeniowej i reasekuracyjnej (Dz.U. 2015 poz. 1844 z późn. zmianami).',
                }
            ]
        }
    ];

    var informationAboutCircumstances = 'Zapoznałem/zapoznałam się z <a href="' + $rootScope.CONFIGURATOR.healthInsurance.dataProcessingAgreementFileUrl + '" target="_blank">treścią obowiązku informacyjnego LUX MED Sp. z o.o.</a>'
    if ($scope.package && $scope.package.type === 'VIP') {
        informationAboutCircumstances += 'oraz <a href="' + $rootScope.CONFIGURATOR.healthInsurance.dataProcessingAgreementFileUrl2 + '" target="_blank">obowiązku informacyjnego LMG Försäkrings AB SA Oddział w Polsce.</a>'
    }
    $scope.requiredStatements = [
        {
            list: [
                {
                    codeName: ['acceptsAccessingInformationAboutCircumstances'],
                    text: 'Oświadczam, że jestem członkiem Okręgowej Izby Radców Prawnych ' + $rootScope.CONFIGURATOR.healthInsuranceWithPayments.oirpLocation +  ', aplikantem lub jej pracownikiem.'
                },
                {
                    codeName: ['acceptsPersonalDataProcessing', 'knowsInformationObligation'],
                    text: informationAboutCircumstances
                }
            ]
        }
    ];

    $scope.optionalStatements = [];

    if ($scope.stateParams.branch) {
        $scope.data.branch = $scope.stateParams.branch.name;
    }

    $scope.data.partner = {};
    $scope.data.children = [];

    $scope.accept = function () {
        console.log($scope.form);
        $scope.form.$setSubmitted();
        $scope.register($scope.form);
    }

    function checkDuplicatedIdentifiers(data) {

        let identifiers = [];
        if (data.person.identifierType && data.person.identifier) {
            identifiers.push(data.person.identifier);
        }

        if (data.partner && data.partner.nationality === 'POLISH' && data.partner.identifier) {
            identifiers.push(data.partner.identifier);
        }

        identifiers = _.concat(identifiers, _.map(_.filter(data.children, {nationality: 'POLISH'}), 'identifier'));
        return Object.entries(_.countBy(identifiers))
            .reduce((acc, [key, val]) => {
                return val > 1 ? acc.concat(key) : acc
            }, [])
            .map(Number)
    }

    $scope.register = function (form) {
        if (!form.$valid) {
            return 0;
        }

        let duplicatedIdentifiers = checkDuplicatedIdentifiers($scope.data);
        if (duplicatedIdentifiers.length > 0) {
            $scope.showPopUp('', '', 'Zgłaszane osoby mają ten sam nr PESEL ' +  _.join(duplicatedIdentifiers, ', ') + ' - sprawdź wypełnione pola');
            return 0;
        }

        var checkedRequiredStatementsCount = 0;
        var requiredAmountOfCheckedRequiredStatements = 0;

        var requiredStatements = $rootScope.CONFIGURATOR.healthInsurance.separateDeductionFromSalary ? $scope.requiredStatementsWitDeductionFromSalary : $scope.requiredStatements;

        angular.forEach(requiredStatements, function (statementsGroup) {
            requiredAmountOfCheckedRequiredStatements = requiredAmountOfCheckedRequiredStatements + statementsGroup.list.length;

            angular.forEach(statementsGroup.list, function (statement) {
                if (statement.checked) {
                    checkedRequiredStatementsCount++;
                }
            });
        });

        if (!isRequiredStatementsChecked(requiredStatements)) {
            $scope.showPopUp('', 'Zaakceptuj oświadczenia', 'Aby zatwierdzić deklarację zaakceptuj wymagane oświadczenia.');
            return 0;
        }

        var $data = angular.copy($scope.data);
        if ($rootScope.CONFIGURATOR.healthInsurance.separateDeductionFromSalary) {
            $data.deductionConsent = true;
            $data.deductionConsentDate = new Date();
        }

        var childrenLength = Object.keys($data.children).length;
        var partnerLength = ($data.partner && Object.keys($data.partner).length) ? 1 : 0;

        if ($scope.package.partner && !$scope.package.children) {
            if (childrenLength + partnerLength < 1) {
                $scope.showPopUp('', 'Dodaj partnera', 'Aby zatwierdzić deklarację musisz dodać partnera lub dziecko.');
                return 0;
            }
        } else if ($scope.package.partner && $scope.package.children) {
            if (childrenLength + partnerLength < 2) {
                $scope.showPopUp('', 'Dodaj osoby', 'Aby zatwierdzić deklarację musisz dodać co najmniej 2 osoby.');
                return 0;
            }
        }

        var len = Object.keys($data.children).length;
        if (len) {
            for (var a = 0; a < len; a++) {
                if ($data.children[a].member === 'CHILD') {
                    if ($data.children[a].nationality === 'POLISH') {
                        if ($filter('isOver26FromIdentifier')($data.children[a].identifier)) {
                            $scope.showPopUp('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 26 lat.', '');
                            return 0;
                        }
                    } else {
                        if ($filter('isOver26FromBirthdate')($data.children[a].birthdate)) {
                            $scope.showPopUp('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 26 lat.', '');
                            return 0;
                        }
                    }
                }
            }
        }

        if ($data.benefit.type === 'SENIOR') {
            if (!validateSenior($data.person, $data.partner)) {
                return 0;
            }
        } else {
            if (!validateNotSenior($data.person)) {
                return 0;
            }
            if (!validateNotSenior($data.partner)) {
                return 0;
            }
        }

         if (Object.keys($data.partner).length) {
            $data.partner.identifierType = ($data.partner.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
            $data.partner.identifier = ($data.partner.nationality !== 'POLISH') ? $data.partner.id : $data.partner.identifier;
            $data.partner.birthdate = ($data.partner.nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.partner.birthdate) : $filter('getDateFromIdentifier')($data.partner.identifier);
            $data.partner.citizenshipType = $data.partner.nationality;
            $data.partner.mainCareLocation = $data.person.mainCareLocation;

            delete $data.partner.nationality;
            delete $data.partner.id;
            delete $data.partner.sameAddress;
        } else {
            delete $data.partner;
        }

        var len = Object.keys($data.children).length;
        if (len) {
            for (var a = 0; a < len; a++) {

                $data.children[a].identifierType = ($data.children[a].nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
                $data.children[a].identifier = ($data.children[a].nationality !== 'POLISH') ? $data.children[a].id : $data.children[a].identifier;
                $data.children[a].birthdate = ($data.children[a].nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.children[a].birthdate) : $filter('getDateFromIdentifier')($data.children[a].identifier);
                $data.children[a].citizenshipType = $data.children[a].nationality;
                $data.children[a].mainCareLocation = $data.person.mainCareLocation;

                if ($data.children[a]) {
                    delete $data.children[a].nationality;
                    delete $data.children[a].id;
                    delete $data.children[a].sameAddress;
                }
            }
        }

        $data.children = $data.children.filter(function () {
            return true;
        });

        $data.person.citizenshipType = $data.person.nationality;
        $data.proposedDate = $scope.stateParams.proposedDate;
        $data.branch = $scope.userData.branch.name;

        if ($scope.packageWithRehabilitation) {
            $data.rehabilitation = true;
        }

        var statements = [].concat(requiredStatements, $scope.optionalStatements);
        applyStatementsToPerson($data.person, statements);
        $data.partner && applyStatementsToPerson($data.partner, statements);
        $data.children && angular.forEach($data.children, function (child) {
            applyStatementsToPerson(child, statements);
        });

        console.log($data);

        healthInsuranceService.add($data, false).then(function (data) {
            if (data.status === 200) {
                dataUser.update();
                $state.go('root.home.healthInsuranceWithPayments.summary', {
                    declaration: data.data,
                });
            } else {
                popUpService.showPopUpWithError(data.data, {
                    ev: '',
                    head: 'Zgłoszenie nieudane',
                    content: 'Niestety nie udało się zgłosić deklaracji, skontaktuj się z administratorem.',
                    text: '',
                    target: ''
                });
            }
        });
    };

    function validateNotSenior(person) {
        if (person && Object.keys(person).length) {
            if (person.nationality === 'POLISH' || person.citizenshipType === 'POLISH') {
                if ($filter('isOver70FromIdentifier')(person.identifier)) {
                    $scope.showPopUp('', 'Błędne dane', 'Do pakietu mogą przystąpić osoby, które nie ukończyły 70 roku życia. Osobom powyżej 70 roku życia dedykowany jest pakiet Senior.', '');
                    return 0;
                }

            } else {
                if ($filter('isOver70FromBirthdate')(new Date(person.birthdate))) {
                    $scope.showPopUp('', 'Błędne dane', 'Do pakietu mogą przystąpić osoby, które nie ukończyły 70 roku życia. Osobom powyżej 70 roku życia dedykowany jest pakiet Senior.', '');
                    return 0;
                }
            }
        }
        return true;
    }

    function validateSenior(person, partner) {
        let isSenior = false;
        if (person && Object.keys(person).length) {
            if (person.nationality === 'POLISH' || person.citizenshipType === 'POLISH') {
                if ($filter('isOver70FromIdentifier')(person.identifier)) {
                    isSenior = true;
                }
            } else {
                if ($filter('isOver70FromBirthdate')(new Date(person.birthdate))) {
                    isSenior = true;
                }
            }
        }
        if (partner) {
            if (partner.nationality === 'POLISH') {
                if ($filter('isOver70FromIdentifier')(partner.identifier)) {
                    isSenior = true;
                }
            } else {
                if ($filter('isOver70FromBirthdate')(new Date(partner.birthdate))) {
                    isSenior = true;
                }
            }
        }
        if (!isSenior) {
            $scope.showPopUp('', 'Błędne dane', 'Do pakietu mogą przystąpić osoby, które ukończyły 70 roku życia.', '');
            return 0;
        }

        return true;
    }

    function isRequiredStatementsChecked(requiredStatements) {
        var checkedRequiredStatementsCount = 0;
        var requiredAmountOfCheckedRequiredStatements = 0;

        angular.forEach(requiredStatements, function (statementsGroup) {
            requiredAmountOfCheckedRequiredStatements = requiredAmountOfCheckedRequiredStatements + statementsGroup.list.length;

            angular.forEach(statementsGroup.list, function (statement) {
                if (statement.checked) {
                    checkedRequiredStatementsCount++;
                }
            });
        });

        return checkedRequiredStatementsCount === requiredAmountOfCheckedRequiredStatements;
    }

    function applyStatementsToPerson(person, statementsGroups) {
        if (!person) {
            return;
        }
        angular.forEach(statementsGroups, function (statementsGroupSingle) {
            angular.forEach(statementsGroupSingle.list, function (statement) {
                if (!statement.codeName) {
                    return;
                }

                var codeNames;

                if (Array.isArray(statement.codeName)) {
                    codeNames = statement.codeName;
                } else {
                    codeNames = [statement.codeName];
                }

                angular.forEach(codeNames, function (codeName) {
                    person[codeName] = !!statement.checked;
                });
            });
        });
    }

    $scope.showInformationObligation = function () {
        $scope.showPopUpInformationObligation('');
    }

    $scope.showPopUp = function (ev, head, content, text, target, exit) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                exit: exit,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {

        }, function () {

        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $mdDialog.hide($scope.locals);
        };
    }
    PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals'];

    $scope.showPopUpInformationObligation = function (ev) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-obligation-declaration.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {}
        }).then(function (data) {

        }, function () {

        });
    }

    $scope.add = function (type) {
        if (type === 'PARTNER') {
            $scope.data.partner = {
                nationality: 'POLISH',
                address: angular.copy($scope.data.person.address),
                sameAddress: true
            };

            $scope.partner_length = 1;
            $scope.partner_block = true;

            if (!$scope.package.children) {
                $scope.children_block = true;
            }
        }

        if (type === 'CHILD') {

            $scope.data.children.push({
                nationality: 'POLISH',
                member: 'CHILD',
                address: angular.copy($scope.data.person.address),
                sameAddress: true
            });

            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = true;
                $scope.children_block = true;
            } else {
                if ($scope.children_length >= $scope.package.children) {
                    $scope.children_block = true;
                }
            }
        }
    }

    var getResults = function (query) {
        var deferred = $q.defer();

        statesService.dataCityLists({
            name: query
        }).then(function (data) {
            deferred.resolve(data.data);
        });

        return deferred.promise;
    };

    // ##### LOCALIZATION FILTER ##### //
    $scope.querySearchLocalization = function (query) {
        if (!query) {
            return;
        }

        return getResults(query).then(function (results) {
            return results;
        });
    };

    $scope.delete = function (obj) {
        if (obj === 'partner') {
            $scope.data.partner = {};
            $scope.partner_length = 0;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.partner_block = false;
            }
        } else {
            $scope.data.children.splice(obj, 1);
            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.children_block = false;
            }
        }
    }

    $scope.$watch('data.person.address', function (oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = angular.copy($scope.data.person.address);
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = angular.copy($scope.data.person.address);
                    }
                }
            }
            $scope.data.person.mainCareLocation = $filter('mainCareLocationFromZipCode')($scope.data.person.address.zipCode);
        }
    }, true);

    $scope.$watch('data.partner.sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            if ($scope.data.partner.sameAddress) {
                $scope.data.partner.address = angular.copy($scope.data.person.address);
                $scope.data.partner.selectedItemLocalization = $scope.selectedItemLocalization;
            } else {
                $scope.data.partner.address = {};
                $scope.data.partner.selectedItemLocalization = null;
            }
        }
    });
    $scope.$watch('data.children[0].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(0);
        }
    });
    $scope.$watch('data.children[1].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(1);
        }
    });
    $scope.$watch('data.children[2].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(2);
        }
    });
    $scope.$watch('data.children[3].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(3);
        }
    });
    $scope.$watch('data.children[4].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(4);
        }
    });
    $scope.$watch('data.children[5].sameAddress', function (oldValue, newValue) {
        if (oldValue !== newValue) {
            onChildrenSameAddressUpdate(5);
        }
    });

    function onChildrenSameAddressUpdate(i) {
        if ($scope.data.children[i].sameAddress) {
            $scope.data.children[i].address = angular.copy($scope.data.person.address);
            $scope.data.children[i].selectedItemLocalization = $scope.selectedItemLocalization;
        } else {
            $scope.data.children[i].address = {};
            $scope.data.children[i].selectedItemLocalization = null;
        }
    }
}]);
